export default function StoneXDivider () {
  return <hr className="divider" style={{ width: '100%' }}/>
}